export default class TypeContratDto {
  id;
  type;
  nbEffectif;
}
